import React from "react";

import { useDataProvider, useNotification } from "@refinedev/core";
import _ from "lodash";
import { Loader2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export interface IOrderBasedTicketAssignmentProps {
  order: any;
  setTickets: any;
}
export function OrderBasedTicketAssignment({
  order,
  setTickets,
}: IOrderBasedTicketAssignmentProps) {
  const [loading, setLoading] = React.useState(false);
  const [orderId, setOrderId] = React.useState("");

  const { custom } = useDataProvider()();
  const { open } = useNotification();

  const onGetTickets = React.useCallback(async () => {
    if (_.isEmpty(orderId)) {
      open?.({
        message: "Order ID is empty",
        description: "Provide a valid Order ID found in order URL",
        type: "error",
      });
    }
    setLoading(true);
    const response = await custom?.({
      url: `${import.meta.env.VITE_FUNCTIONS_BASE_URL}/bots-tickets`,
      method: "post",
      payload: {
        orderId,
        provider: order.ticketing.provider,
      },
    });
    setLoading(false);
    if (!response) {
      open?.({
        message: `Response to provider failed for provider ${order.ticketing.provider}`,
        type: "error",
      });
      return;
    }

    setTickets((prev: any) => [...prev, ...response.data.tickets]);
  }, [orderId]);
  return (
    <div>
      <Label>Order ID</Label>
      <div className="flex flex-row gap-2 align-center">
        <Input
          value={orderId}
          onChange={(e) => setOrderId(e.target.value)}
          placeholder="Order ID from provider"
        />
        <Button onClick={onGetTickets}>
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          {loading ? "Loading..." : "Get Tickets"}
        </Button>
      </div>
    </div>
  );
}
